import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

type CmsContent = Record<string, string>;

export const useCmsContent = () => {
  const [content, setContent] = useState<CmsContent>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("app_settings")
      .select("key, value")
      .then(({ data }) => {
        const map: CmsContent = {};
        (data || []).forEach((row: any) => {
          try {
            let val = row.value;
            // jsonb returns parsed values — ensure we get a string
            if (typeof val === "string") {
              // Remove surrounding quotes if double-encoded
              if (val.startsWith('"') && val.endsWith('"')) {
                val = val.slice(1, -1);
              }
            } else if (val !== null && val !== undefined) {
              val = String(val);
            } else {
              val = "";
            }
            map[row.key] = val;
          } catch {
            map[row.key] = String(row.value ?? "");
          }
        });
        setContent(map);
        setLoading(false);
      });
  }, []);

  return { content, loading };
};
